import React from 'react';
import { observer } from 'mobx-react';
import { TreeStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class TreeCreate extends React.Component {

  onCreate = name => {
    TreeStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a tree name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default TreeCreate;
